module.exports = "images/enfants_6.555d29b6.png";